//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface IDailyLogClient {
    /**
     * @return Success
     */
    dailyLog(customer: string, environment: string, date: Date, objectType: ObjectType): Promise<DailyLog>;
    /**
     * @return Success
     */
    dailyLogAll(customer: string, environment: string, date: Date): Promise<DailyLog[]>;
    /**
     * @return Success
     */
    dailyLogAll2(customer: string, environment: string, firstDate: Date, lastDate: Date): Promise<DailyLog[]>;
    /**
     * @return Success
     */
    dailyLogAll3(customer: string, environment: string, firstDate: Date, lastDate: Date, objectType: ObjectType): Promise<DailyLog[]>;
}

export class DailyLogClient implements IDailyLogClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    dailyLog(customer: string, environment: string, date: Date, objectType: ObjectType, cancelToken?: CancelToken | undefined): Promise<DailyLog> {
        let url_ = this.baseUrl + "/DailyLog/{customer}/{environment}/{date}/{objecttype}";
        if (customer === undefined || customer === null)
            throw new Error("The parameter 'customer' must be defined.");
        url_ = url_.replace("{customer}", encodeURIComponent("" + customer));
        if (environment === undefined || environment === null)
            throw new Error("The parameter 'environment' must be defined.");
        url_ = url_.replace("{environment}", encodeURIComponent("" + environment));
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent(date ? "" + date.toISOString() : "null"));
        if (objectType === undefined || objectType === null)
            throw new Error("The parameter 'objectType' must be defined.");
        url_ = url_.replace("{objectType}", encodeURIComponent("" + objectType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDailyLog(_response);
        });
    }

    protected processDailyLog(response: AxiosResponse): Promise<DailyLog> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DailyLog>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DailyLog>(null as any);
    }

    /**
     * @return Success
     */
    dailyLogAll(customer: string, environment: string, date: Date, cancelToken?: CancelToken | undefined): Promise<DailyLog[]> {
        let url_ = this.baseUrl + "/DailyLog/{customer}/{environment}/{date}";
        if (customer === undefined || customer === null)
            throw new Error("The parameter 'customer' must be defined.");
        url_ = url_.replace("{customer}", encodeURIComponent("" + customer));
        if (environment === undefined || environment === null)
            throw new Error("The parameter 'environment' must be defined.");
        url_ = url_.replace("{environment}", encodeURIComponent("" + environment));
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent(date ? "" + date.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDailyLogAll(_response);
        });
    }

    protected processDailyLogAll(response: AxiosResponse): Promise<DailyLog[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DailyLog[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DailyLog[]>(null as any);
    }

    /**
     * @return Success
     */
    dailyLogAll2(customer: string, environment: string, firstDate: Date, lastDate: Date, cancelToken?: CancelToken | undefined): Promise<DailyLog[]> {
        let url_ = this.baseUrl + "/DailyLog/{customer}/{environment}/{firstDate}/{lastDate}";
        if (customer === undefined || customer === null)
            throw new Error("The parameter 'customer' must be defined.");
        url_ = url_.replace("{customer}", encodeURIComponent("" + customer));
        if (environment === undefined || environment === null)
            throw new Error("The parameter 'environment' must be defined.");
        url_ = url_.replace("{environment}", encodeURIComponent("" + environment));
        if (firstDate === undefined || firstDate === null)
            throw new Error("The parameter 'firstDate' must be defined.");
        url_ = url_.replace("{firstDate}", encodeURIComponent(firstDate ? "" + firstDate.toISOString() : "null"));
        if (lastDate === undefined || lastDate === null)
            throw new Error("The parameter 'lastDate' must be defined.");
        url_ = url_.replace("{lastDate}", encodeURIComponent(lastDate ? "" + lastDate.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDailyLogAll2(_response);
        });
    }

    protected processDailyLogAll2(response: AxiosResponse): Promise<DailyLog[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DailyLog[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DailyLog[]>(null as any);
    }

    /**
     * @return Success
     */
    dailyLogAll3(customer: string, environment: string, firstDate: Date, lastDate: Date, objectType: ObjectType, cancelToken?: CancelToken | undefined): Promise<DailyLog[]> {
        let url_ = this.baseUrl + "/DailyLog/{customer}/{environment}/{firstDate}/{lastDate}/{objectType}";
        if (customer === undefined || customer === null)
            throw new Error("The parameter 'customer' must be defined.");
        url_ = url_.replace("{customer}", encodeURIComponent("" + customer));
        if (environment === undefined || environment === null)
            throw new Error("The parameter 'environment' must be defined.");
        url_ = url_.replace("{environment}", encodeURIComponent("" + environment));
        if (firstDate === undefined || firstDate === null)
            throw new Error("The parameter 'firstDate' must be defined.");
        url_ = url_.replace("{firstDate}", encodeURIComponent(firstDate ? "" + firstDate.toISOString() : "null"));
        if (lastDate === undefined || lastDate === null)
            throw new Error("The parameter 'lastDate' must be defined.");
        url_ = url_.replace("{lastDate}", encodeURIComponent(lastDate ? "" + lastDate.toISOString() : "null"));
        if (objectType === undefined || objectType === null)
            throw new Error("The parameter 'objectType' must be defined.");
        url_ = url_.replace("{objectType}", encodeURIComponent("" + objectType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDailyLogAll3(_response);
        });
    }

    protected processDailyLogAll3(response: AxiosResponse): Promise<DailyLog[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DailyLog[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DailyLog[]>(null as any);
    }
}

export interface IDashboardClient {
    /**
     * @param body (optional) 
     * @return Success
     */
    dashboard(body?: DashboardRequestDto | undefined): Promise<DashboardResponseDto[]>;
}

export class DashboardClient implements IDashboardClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    dashboard(body?: DashboardRequestDto | undefined, cancelToken?: CancelToken | undefined): Promise<DashboardResponseDto[]> {
        let url_ = this.baseUrl + "/Dashboard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDashboard(_response);
        });
    }

    protected processDashboard(response: AxiosResponse): Promise<DashboardResponseDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DashboardResponseDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DashboardResponseDto[]>(null as any);
    }
}

export interface IEnvironmentClient {
    /**
     * @return Success
     */
    environment(): Promise<string[]>;
    /**
     * @return Success
     */
    environmentAll(customer: string): Promise<EnvironmentResponseDto[]>;
    /**
     * @return Success
     */
    environmentAll2(): Promise<EnvironmentResponseDto[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    environmentPOST(body?: EnvironmentRequestDto | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    environmentPUT(body?: EnvironmentRequestDto | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    environmentDELETE(body?: EnvironmentRequestDeleteDto | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    customerPOST(body?: string | undefined): Promise<void>;
    /**
     * @param body (optional) 
     * @return Success
     */
    customerDELETE(body?: string | undefined): Promise<void>;
    /**
     * @return Success
     */
    contactGET(customer: string, environment: string): Promise<ContactDetailsResponseDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    contactPOST(body?: ContactDetailsRequestDto | undefined): Promise<void>;
}

export class EnvironmentClient implements IEnvironmentClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    environment( cancelToken?: CancelToken | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/Environment";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnvironment(_response);
        });
    }

    protected processEnvironment(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<string[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @return Success
     */
    environmentAll(customer: string, cancelToken?: CancelToken | undefined): Promise<EnvironmentResponseDto[]> {
        let url_ = this.baseUrl + "/Environment/environment/{customer}";
        if (customer === undefined || customer === null)
            throw new Error("The parameter 'customer' must be defined.");
        url_ = url_.replace("{customer}", encodeURIComponent("" + customer));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnvironmentAll(_response);
        });
    }

    protected processEnvironmentAll(response: AxiosResponse): Promise<EnvironmentResponseDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EnvironmentResponseDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvironmentResponseDto[]>(null as any);
    }

    /**
     * @return Success
     */
    environmentAll2( cancelToken?: CancelToken | undefined): Promise<EnvironmentResponseDto[]> {
        let url_ = this.baseUrl + "/Environment/environment";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnvironmentAll2(_response);
        });
    }

    protected processEnvironmentAll2(response: AxiosResponse): Promise<EnvironmentResponseDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EnvironmentResponseDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EnvironmentResponseDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    environmentPOST(body?: EnvironmentRequestDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Environment/environment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnvironmentPOST(_response);
        });
    }

    protected processEnvironmentPOST(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    environmentPUT(body?: EnvironmentRequestDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Environment/environment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnvironmentPUT(_response);
        });
    }

    protected processEnvironmentPUT(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    environmentDELETE(body?: EnvironmentRequestDeleteDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Environment/environment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEnvironmentDELETE(_response);
        });
    }

    protected processEnvironmentDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    customerPOST(body?: string | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Environment/customer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCustomerPOST(_response);
        });
    }

    protected processCustomerPOST(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    customerDELETE(body?: string | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Environment/customer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCustomerDELETE(_response);
        });
    }

    protected processCustomerDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    contactGET(customer: string, environment: string, cancelToken?: CancelToken | undefined): Promise<ContactDetailsResponseDto> {
        let url_ = this.baseUrl + "/Environment/contact/{customer}/{environment}";
        if (customer === undefined || customer === null)
            throw new Error("The parameter 'customer' must be defined.");
        url_ = url_.replace("{customer}", encodeURIComponent("" + customer));
        if (environment === undefined || environment === null)
            throw new Error("The parameter 'environment' must be defined.");
        url_ = url_.replace("{environment}", encodeURIComponent("" + environment));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processContactGET(_response);
        });
    }

    protected processContactGET(response: AxiosResponse): Promise<ContactDetailsResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ContactDetailsResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContactDetailsResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    contactPOST(body?: ContactDetailsRequestDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Environment/contact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processContactPOST(_response);
        });
    }

    protected processContactPOST(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IFeatureClient {
    /**
     * @return Success
     */
    featureGET(): Promise<{ [key: string]: string; }>;
    /**
     * @param body (optional) 
     * @return Success
     */
    featurePUT(body?: FeatureRequestDto | undefined): Promise<FeatureResponseDto>;
    /**
     * @return Success
     */
    featureAll(customer: string, environment: string): Promise<FeatureResponseDto[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    features(body?: FeaturesRequestDto | undefined): Promise<void>;
}

export class FeatureClient implements IFeatureClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    featureGET( cancelToken?: CancelToken | undefined): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/Feature";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFeatureGET(_response);
        });
    }

    protected processFeatureGET(response: AxiosResponse): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<{ [key: string]: string; }>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    featurePUT(body?: FeatureRequestDto | undefined, cancelToken?: CancelToken | undefined): Promise<FeatureResponseDto> {
        let url_ = this.baseUrl + "/Feature";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFeaturePUT(_response);
        });
    }

    protected processFeaturePUT(response: AxiosResponse): Promise<FeatureResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FeatureResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FeatureResponseDto>(null as any);
    }

    /**
     * @return Success
     */
    featureAll(customer: string, environment: string, cancelToken?: CancelToken | undefined): Promise<FeatureResponseDto[]> {
        let url_ = this.baseUrl + "/Feature/{customer}/{environment}";
        if (customer === undefined || customer === null)
            throw new Error("The parameter 'customer' must be defined.");
        url_ = url_.replace("{customer}", encodeURIComponent("" + customer));
        if (environment === undefined || environment === null)
            throw new Error("The parameter 'environment' must be defined.");
        url_ = url_.replace("{environment}", encodeURIComponent("" + environment));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFeatureAll(_response);
        });
    }

    protected processFeatureAll(response: AxiosResponse): Promise<FeatureResponseDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<FeatureResponseDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FeatureResponseDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    features(body?: FeaturesRequestDto | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Feature/features";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFeatures(_response);
        });
    }

    protected processFeatures(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IQueueLogClient {
    /**
     * @return Success
     */
    date(customer: string, environment: string, date: Date, objectType: ObjectType): Promise<QueueLogMessage[]>;
    /**
     * @return Success
     */
    range(customer: string, environment: string, firstDate: Date, lastDate: Date): Promise<QueueLogMessage[]>;
    /**
     * @return Success
     */
    range2(customer: string, environment: string, firstDate: Date, lastDate: Date, objectType: ObjectType): Promise<QueueLogMessage[]>;
    /**
     * @return Success
     */
    message(customer: string, environment: string, id: string, objectType: ObjectType): Promise<QueueLogMessage[]>;
}

export class QueueLogClient implements IQueueLogClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    date(customer: string, environment: string, date: Date, objectType: ObjectType, cancelToken?: CancelToken | undefined): Promise<QueueLogMessage[]> {
        let url_ = this.baseUrl + "/QueueLog/{customer}/{environment}/date/{date}/{objectType}";
        if (customer === undefined || customer === null)
            throw new Error("The parameter 'customer' must be defined.");
        url_ = url_.replace("{customer}", encodeURIComponent("" + customer));
        if (environment === undefined || environment === null)
            throw new Error("The parameter 'environment' must be defined.");
        url_ = url_.replace("{environment}", encodeURIComponent("" + environment));
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent(date ? "" + date.toISOString() : "null"));
        if (objectType === undefined || objectType === null)
            throw new Error("The parameter 'objectType' must be defined.");
        url_ = url_.replace("{objectType}", encodeURIComponent("" + objectType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDate(_response);
        });
    }

    protected processDate(response: AxiosResponse): Promise<QueueLogMessage[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<QueueLogMessage[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueueLogMessage[]>(null as any);
    }

    /**
     * @return Success
     */
    range(customer: string, environment: string, firstDate: Date, lastDate: Date, cancelToken?: CancelToken | undefined): Promise<QueueLogMessage[]> {
        let url_ = this.baseUrl + "/QueueLog/{customer}/{environment}/range/{firstDate}/{lastDate}";
        if (customer === undefined || customer === null)
            throw new Error("The parameter 'customer' must be defined.");
        url_ = url_.replace("{customer}", encodeURIComponent("" + customer));
        if (environment === undefined || environment === null)
            throw new Error("The parameter 'environment' must be defined.");
        url_ = url_.replace("{environment}", encodeURIComponent("" + environment));
        if (firstDate === undefined || firstDate === null)
            throw new Error("The parameter 'firstDate' must be defined.");
        url_ = url_.replace("{firstDate}", encodeURIComponent(firstDate ? "" + firstDate.toISOString() : "null"));
        if (lastDate === undefined || lastDate === null)
            throw new Error("The parameter 'lastDate' must be defined.");
        url_ = url_.replace("{lastDate}", encodeURIComponent(lastDate ? "" + lastDate.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRange(_response);
        });
    }

    protected processRange(response: AxiosResponse): Promise<QueueLogMessage[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<QueueLogMessage[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueueLogMessage[]>(null as any);
    }

    /**
     * @return Success
     */
    range2(customer: string, environment: string, firstDate: Date, lastDate: Date, objectType: ObjectType, cancelToken?: CancelToken | undefined): Promise<QueueLogMessage[]> {
        let url_ = this.baseUrl + "/QueueLog/{customer}/{environment}/range/{firstDate}/{lastDate}/{objectType}";
        if (customer === undefined || customer === null)
            throw new Error("The parameter 'customer' must be defined.");
        url_ = url_.replace("{customer}", encodeURIComponent("" + customer));
        if (environment === undefined || environment === null)
            throw new Error("The parameter 'environment' must be defined.");
        url_ = url_.replace("{environment}", encodeURIComponent("" + environment));
        if (firstDate === undefined || firstDate === null)
            throw new Error("The parameter 'firstDate' must be defined.");
        url_ = url_.replace("{firstDate}", encodeURIComponent(firstDate ? "" + firstDate.toISOString() : "null"));
        if (lastDate === undefined || lastDate === null)
            throw new Error("The parameter 'lastDate' must be defined.");
        url_ = url_.replace("{lastDate}", encodeURIComponent(lastDate ? "" + lastDate.toISOString() : "null"));
        if (objectType === undefined || objectType === null)
            throw new Error("The parameter 'objectType' must be defined.");
        url_ = url_.replace("{objectType}", encodeURIComponent("" + objectType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRange2(_response);
        });
    }

    protected processRange2(response: AxiosResponse): Promise<QueueLogMessage[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<QueueLogMessage[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueueLogMessage[]>(null as any);
    }

    /**
     * @return Success
     */
    message(customer: string, environment: string, id: string, objectType: ObjectType, cancelToken?: CancelToken | undefined): Promise<QueueLogMessage[]> {
        let url_ = this.baseUrl + "/QueueLog/{customer}/{environment}/message/{objectType}/{id}";
        if (customer === undefined || customer === null)
            throw new Error("The parameter 'customer' must be defined.");
        url_ = url_.replace("{customer}", encodeURIComponent("" + customer));
        if (environment === undefined || environment === null)
            throw new Error("The parameter 'environment' must be defined.");
        url_ = url_.replace("{environment}", encodeURIComponent("" + environment));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (objectType === undefined || objectType === null)
            throw new Error("The parameter 'objectType' must be defined.");
        url_ = url_.replace("{objectType}", encodeURIComponent("" + objectType));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMessage(_response);
        });
    }

    protected processMessage(response: AxiosResponse): Promise<QueueLogMessage[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<QueueLogMessage[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueueLogMessage[]>(null as any);
    }
}

export interface IRelationClient {
    /**
     * @return Success
     */
    csvGET(): Promise<FileResponse>;
    /**
     * @return Success
     */
    csvGET2(customer: string, environment: string): Promise<FileResponse>;
    /**
     * @return Success
     */
    csvGET3(customer: string, environment: string, type: ObjectType): Promise<FileResponse>;
    /**
     * @return Success
     */
    relationsGET(customer: string, environment: string): Promise<RelationResponseDto[]>;
    /**
     * @return Success
     */
    relationsGET2(customer: string, environment: string, type: ObjectType): Promise<RelationResponseDto[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    relationsPUT(body?: RelationRequestUpdateDto | undefined): Promise<RelationResponseDto[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    relationsPOST(body?: RelationsRequestDto | undefined): Promise<RelationResponseDto[]>;
    /**
     * @param customerName (optional) 
     * @param environment (optional) 
     * @param file (optional) 
     * @return Success
     */
    csvPOST(customerName?: string | undefined, environment?: string | undefined, file?: FileParameter | undefined): Promise<void>;
    /**
     * @param customerName (optional) 
     * @param environment (optional) 
     * @param file (optional) 
     * @param objectType (optional) 
     * @return Success
     */
    type(customerName?: string | undefined, environment?: string | undefined, file?: FileParameter | undefined, objectType?: ObjectType | undefined): Promise<void>;
}

export class RelationClient implements IRelationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    csvGET( cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Relation/relations/csv";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCsvGET(_response);
        });
    }

    protected processCsvGET(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    csvGET2(customer: string, environment: string, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Relation/relations/csv/{customer}/{environment}";
        if (customer === undefined || customer === null)
            throw new Error("The parameter 'customer' must be defined.");
        url_ = url_.replace("{customer}", encodeURIComponent("" + customer));
        if (environment === undefined || environment === null)
            throw new Error("The parameter 'environment' must be defined.");
        url_ = url_.replace("{environment}", encodeURIComponent("" + environment));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCsvGET2(_response);
        });
    }

    protected processCsvGET2(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    csvGET3(customer: string, environment: string, type: ObjectType, cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Relation/relations/csv/{type}/{customer}/{environment}";
        if (customer === undefined || customer === null)
            throw new Error("The parameter 'customer' must be defined.");
        url_ = url_.replace("{customer}", encodeURIComponent("" + customer));
        if (environment === undefined || environment === null)
            throw new Error("The parameter 'environment' must be defined.");
        url_ = url_.replace("{environment}", encodeURIComponent("" + environment));
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCsvGET3(_response);
        });
    }

    protected processCsvGET3(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Success
     */
    relationsGET(customer: string, environment: string, cancelToken?: CancelToken | undefined): Promise<RelationResponseDto[]> {
        let url_ = this.baseUrl + "/Relation/relations/{customer}/{environment}";
        if (customer === undefined || customer === null)
            throw new Error("The parameter 'customer' must be defined.");
        url_ = url_.replace("{customer}", encodeURIComponent("" + customer));
        if (environment === undefined || environment === null)
            throw new Error("The parameter 'environment' must be defined.");
        url_ = url_.replace("{environment}", encodeURIComponent("" + environment));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRelationsGET(_response);
        });
    }

    protected processRelationsGET(response: AxiosResponse): Promise<RelationResponseDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RelationResponseDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RelationResponseDto[]>(null as any);
    }

    /**
     * @return Success
     */
    relationsGET2(customer: string, environment: string, type: ObjectType, cancelToken?: CancelToken | undefined): Promise<RelationResponseDto[]> {
        let url_ = this.baseUrl + "/Relation/relations/{type}/{customer}/{environment}";
        if (customer === undefined || customer === null)
            throw new Error("The parameter 'customer' must be defined.");
        url_ = url_.replace("{customer}", encodeURIComponent("" + customer));
        if (environment === undefined || environment === null)
            throw new Error("The parameter 'environment' must be defined.");
        url_ = url_.replace("{environment}", encodeURIComponent("" + environment));
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRelationsGET2(_response);
        });
    }

    protected processRelationsGET2(response: AxiosResponse): Promise<RelationResponseDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RelationResponseDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RelationResponseDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    relationsPUT(body?: RelationRequestUpdateDto | undefined, cancelToken?: CancelToken | undefined): Promise<RelationResponseDto[]> {
        let url_ = this.baseUrl + "/Relation/relations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRelationsPUT(_response);
        });
    }

    protected processRelationsPUT(response: AxiosResponse): Promise<RelationResponseDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RelationResponseDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RelationResponseDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    relationsPOST(body?: RelationsRequestDto | undefined, cancelToken?: CancelToken | undefined): Promise<RelationResponseDto[]> {
        let url_ = this.baseUrl + "/Relation/relations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRelationsPOST(_response);
        });
    }

    protected processRelationsPOST(response: AxiosResponse): Promise<RelationResponseDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RelationResponseDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RelationResponseDto[]>(null as any);
    }

    /**
     * @param customerName (optional) 
     * @param environment (optional) 
     * @param file (optional) 
     * @return Success
     */
    csvPOST(customerName?: string | undefined, environment?: string | undefined, file?: FileParameter | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/csv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (customerName === null || customerName === undefined)
            throw new Error("The parameter 'customerName' cannot be null.");
        else
            content_.append("CustomerName", customerName.toString());
        if (environment === null || environment === undefined)
            throw new Error("The parameter 'environment' cannot be null.");
        else
            content_.append("Environment", environment.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCsvPOST(_response);
        });
    }

    protected processCsvPOST(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param customerName (optional) 
     * @param environment (optional) 
     * @param file (optional) 
     * @param objectType (optional) 
     * @return Success
     */
    type(customerName?: string | undefined, environment?: string | undefined, file?: FileParameter | undefined, objectType?: ObjectType | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/csv/type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (customerName === null || customerName === undefined)
            throw new Error("The parameter 'customerName' cannot be null.");
        else
            content_.append("CustomerName", customerName.toString());
        if (environment === null || environment === undefined)
            throw new Error("The parameter 'environment' cannot be null.");
        else
            content_.append("Environment", environment.toString());
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (objectType === null || objectType === undefined)
            throw new Error("The parameter 'objectType' cannot be null.");
        else
            content_.append("ObjectType", objectType.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processType(_response);
        });
    }

    protected processType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IScenarioRunClient {
    /**
     * @param take (optional) 
     * @return Success
     */
    scenarioRuns(customer: string, environment: string, take?: number | undefined): Promise<ScenarioRunList>;
    /**
     * @return Success
     */
    scenarioRun(customer: string, environment: string, runId: string): Promise<ScenarioRunState>;
    /**
     * @return Success
     */
    scenarioSuites(customer: string, environment: string): Promise<ScenarioSuiteSummary[]>;
    /**
     * @param body (optional)
     * @return Success
     */
    startScenarioRun(customer: string, environment: string, body?: ScenarioRunRequest | undefined): Promise<ScenarioRunStarted>;
}

export class ScenarioRunClient implements IScenarioRunClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param take (optional) 
     * @return Success
     */
    scenarioRuns(customer: string, environment: string, take?: number | undefined, cancelToken?: CancelToken | undefined): Promise<ScenarioRunList> {
        let url_ = this.baseUrl + "/ScenarioRun/{customer}/{environment}?";
        if (customer === undefined || customer === null)
            throw new Error("The parameter 'customer' must be defined.");
        url_ = url_.replace("{customer}", encodeURIComponent("" + customer));
        if (environment === undefined || environment === null)
            throw new Error("The parameter 'environment' must be defined.");
        url_ = url_.replace("{environment}", encodeURIComponent("" + environment));
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processScenarioRuns(_response);
        });
    }

    protected processScenarioRuns(response: AxiosResponse): Promise<ScenarioRunList> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ScenarioRunList>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScenarioRunList>(null as any);
    }

    /**
     * @return Success
     */
    scenarioRun(customer: string, environment: string, runId: string, cancelToken?: CancelToken | undefined): Promise<ScenarioRunState> {
        let url_ = this.baseUrl + "/ScenarioRun/{customer}/{environment}/{runId}";
        if (customer === undefined || customer === null)
            throw new Error("The parameter 'customer' must be defined.");
        url_ = url_.replace("{customer}", encodeURIComponent("" + customer));
        if (environment === undefined || environment === null)
            throw new Error("The parameter 'environment' must be defined.");
        url_ = url_.replace("{environment}", encodeURIComponent("" + environment));
        if (runId === undefined || runId === null)
            throw new Error("The parameter 'runId' must be defined.");
        url_ = url_.replace("{runId}", encodeURIComponent("" + runId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processScenarioRun(_response);
        });
    }

    protected processScenarioRun(response: AxiosResponse): Promise<ScenarioRunState> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ScenarioRunState>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScenarioRunState>(null as any);
    }

    /**
     * @return Success
     */
    scenarioSuites(customer: string, environment: string, cancelToken?: CancelToken | undefined): Promise<ScenarioSuiteSummary[]> {
        let url_ = this.baseUrl + "/ScenarioRun/{customer}/{environment}/suites";
        if (customer === undefined || customer === null)
            throw new Error("The parameter 'customer' must be defined.");
        url_ = url_.replace("{customer}", encodeURIComponent("" + customer));
        if (environment === undefined || environment === null)
            throw new Error("The parameter 'environment' must be defined.");
        url_ = url_.replace("{environment}", encodeURIComponent("" + environment));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processScenarioSuites(_response);
        });
    }

    protected processScenarioSuites(response: AxiosResponse): Promise<ScenarioSuiteSummary[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ScenarioSuiteSummary[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScenarioSuiteSummary[]>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    startScenarioRun(customer: string, environment: string, body?: ScenarioRunRequest | undefined, cancelToken?: CancelToken | undefined): Promise<ScenarioRunStarted> {
        let url_ = this.baseUrl + "/ScenarioRun/{customer}/{environment}";
        if (customer === undefined || customer === null)
            throw new Error("The parameter 'customer' must be defined.");
        url_ = url_.replace("{customer}", encodeURIComponent("" + customer));
        if (environment === undefined || environment === null)
            throw new Error("The parameter 'environment' must be defined.");
        url_ = url_.replace("{environment}", encodeURIComponent("" + environment));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStartScenarioRun(_response);
        });
    }

    protected processStartScenarioRun(response: AxiosResponse): Promise<ScenarioRunStarted> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ScenarioRunStarted>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScenarioRunStarted>(null as any);
    }
}

export interface ISettingClient {
    /**
     * @return Success
     */
    settingAll(customer: string, environment: string): Promise<SettingResponseDto[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    settingPOST(body?: SettingRequestDto | undefined): Promise<SettingResponseDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    settingPUT(body?: SettingRequestDto | undefined): Promise<SettingResponseDto>;
    /**
     * @param body (optional) 
     * @return Success
     */
    settingDELETE(body?: SettingRequestDeleteDto | undefined): Promise<SettingResponseDto>;
}

export class SettingClient implements ISettingClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    settingAll(customer: string, environment: string, cancelToken?: CancelToken | undefined): Promise<SettingResponseDto[]> {
        let url_ = this.baseUrl + "/Setting/{customer}/{environment}";
        if (customer === undefined || customer === null)
            throw new Error("The parameter 'customer' must be defined.");
        url_ = url_.replace("{customer}", encodeURIComponent("" + customer));
        if (environment === undefined || environment === null)
            throw new Error("The parameter 'environment' must be defined.");
        url_ = url_.replace("{environment}", encodeURIComponent("" + environment));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSettingAll(_response);
        });
    }

    protected processSettingAll(response: AxiosResponse): Promise<SettingResponseDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SettingResponseDto[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SettingResponseDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    settingPOST(body?: SettingRequestDto | undefined, cancelToken?: CancelToken | undefined): Promise<SettingResponseDto> {
        let url_ = this.baseUrl + "/Setting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSettingPOST(_response);
        });
    }

    protected processSettingPOST(response: AxiosResponse): Promise<SettingResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SettingResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SettingResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    settingPUT(body?: SettingRequestDto | undefined, cancelToken?: CancelToken | undefined): Promise<SettingResponseDto> {
        let url_ = this.baseUrl + "/Setting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSettingPUT(_response);
        });
    }

    protected processSettingPUT(response: AxiosResponse): Promise<SettingResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SettingResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SettingResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    settingDELETE(body?: SettingRequestDeleteDto | undefined, cancelToken?: CancelToken | undefined): Promise<SettingResponseDto> {
        let url_ = this.baseUrl + "/Setting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSettingDELETE(_response);
        });
    }

    protected processSettingDELETE(response: AxiosResponse): Promise<SettingResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SettingResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SettingResponseDto>(null as any);
    }
}

export interface ContactDetailsRequestDto {
    customerName?: string | undefined;
    environment?: string | undefined;
    streetName?: string | undefined;
    houseNumber?: number;
    additional?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface ContactDetailsResponseDto {
    streetName?: string | undefined;
    houseNumber?: number;
    additional?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface DailyLog {
    partitionKey?: string | undefined;
    rowKey?: string | undefined;
    timestamp?: Date;
    eTag?: string | undefined;
    eventDate?: Date;
    objectType?: ObjectType;
    eventType?: EventType;
    countSuccessful?: number;
    countFailed?: number;
    source?: EventSource;
}

export interface DashboardRequestDto {
    viewType?: DashboardViewType;
    logsDate?: Date;
}

export interface DashboardResponseDto {
    customerName?: string | undefined;
    customerEnvironment?: string | undefined;
    dailyLogs?: DailyLog[] | undefined;
    tokenOk: boolean
}

export enum DashboardViewType {
    Prod = "Prod",
    Test = "Test",
    All = "All",
}

export interface EnvironmentRequestDeleteDto {
    customerName?: string | undefined;
    environment?: string | undefined;
}

export interface EnvironmentRequestDto {
    customerName?: string | undefined;
    environment?: string | undefined;
    connectionString?: string | undefined;
}

export interface EnvironmentResponseDto {
    customerName?: string | undefined;
    environment?: string | undefined;
}

export enum EventSource {
    None = "None",
    Leading = "Leading",
    Depending = "Depending",
}

export enum FeatureName {
    None = "None",
    DiscountAsProduct = "DiscountAsProduct",
    CreditBalance = "CreditBalance",
    CreditNoteJournal = "CreditNoteJournal",
    SalesInvoicePrint = "SalesInvoicePrint",
    SalesInvoiceJournal = "SalesInvoiceJournal",
    PaymentOnlineAmountDc = "PaymentOnlineAmountDc",
    InvoiceAsSalesEntry = "InvoiceAsSalesEntry",
    SalesEntryDocument = "SalesEntryDocument",
    SalesEntryDocumentDelete = "SalesEntryDocumentDelete",
    SalesEntryDiscountVat = "SalesEntryDiscountVat",
    TimeDifferenceExactServer = "TimeDifferenceExactServer",
    EnsureCustomerSynced = "EnsureCustomerSynced",
    EnsureProductSynced = "EnsureProductSynced",
    EnsureChargebeeSynced = "EnsureChargebeeSynced",
    MergeTieredLineQuantity = "MergeTieredLineQuantity",
    SalesEntryNumberFromInvoiceNumberDisabled = "SalesEntryNumberFromInvoiceNumberDisabled",
    PoNumberOnDescription = "PoNumberOnDescription",
    DefaultProductGroup = "DefaultProductGroup",
    SyncRefundedPayments = "SyncRefundedPayments",
    DoNotSyncBackProducts = "DoNotSyncBackProducts",
    CustomerClearInvalidVatNumber = "CustomerClearInvalidVatNumber",
    SkipCurrencyMismatchEntries = "SkipCurrencyMismatchEntries",
    AdjustEntriesForClosedFinancialPeriods = "AdjustEntriesForClosedFinancialPeriods",
    EnrichLineItemFamily = "EnrichLineItemFamily",
    SalesEntryCost = "SalesEntryCost",
    DoNotSyncOnlinePayments = "DoNotSyncOnlinePayments",
    UseProductAccountingDetails = "UseProductAccountingDetails",
    SaveProductCodeInEntryLineNote = "SaveProductCodeInEntryLineNote",
    MatchCustomerOnEmail = "MatchCustomerOnEmail",
    UseReferencesForEntryLineItemLookup = "UseReferencesForEntryLineItemLookup",
    DoNotUseDeferredRevenue = "DoNotUseDeferredRevenue",
    UseModelStateComparion = "UseModelStateComparion",
    DoNotUseReconciliation = "DoNotUseReconciliation",
    DoNotSyncCustomerUpdates = "DoNotSyncCustomerUpdates",
    SyncPromotionalCreditsAsDiscounts = "SyncPromotionalCreditsAsDiscounts",
    SyncPromotionalCreditsWithTax = "SyncPromotionalCreditsWithTax",
    SyncDiscountsUsingCoupons = "SyncDiscountsUsingCoupons",
    SyncTransactionGatewayIdToInvoice = "SyncTransactionGatewayIdToInvoice",
    EnableSupportForMultiEntity = "EnableSupportForMultiEntity",
    RedirectAdhocToSpecificExactProduct = "RedirectAdhocToSpecificExactProduct",
    DoNotSyncAppStoreInvoices = "DoNotSyncAppStoreInvoices",
    DefaultCreditNotePaymentCondition = "DefaultCreditNotePaymentCondition",
}

export interface FeatureRequestDto {
    customerName?: string | undefined;
    environment?: string | undefined;
    featureName?: FeatureName;
}

export interface FeatureResponseDto {
    featureName?: string | undefined;
    featureStatus?: boolean;
    featureDescription?: string | undefined;
}

export interface FeaturesRequestDto {
    customerName?: string | undefined;
    environment?: string | undefined;
    features?: UpdateFeatureRequestDto[] | undefined;
}

export enum LogMessageLevel {
    Verbose = "Verbose",
    Information = "Information",
    Warning = "Warning",
    Error = "Error",
}

export enum ObjectType {
    Undefined = "Undefined",
    Customer = "Customer",
    Subscription = "Subscription",
    Order = "Order",
    Invoice = "Invoice",
    InvoiceLine = "InvoiceLine",
    CreditNote = "CreditNote",
    CreditNoteLine = "CreditNoteLine",
    Chargeback = "Chargeback",
    InvoiceSalesEntry = "InvoiceSalesEntry",
    InvoiceSalesEntryLine = "InvoiceSalesEntryLine",
    CreditNoteSalesEntry = "CreditNoteSalesEntry",
    CreditNoteSalesEntryLine = "CreditNoteSalesEntryLine",
    Payment = "Payment",
    PaymentLine = "PaymentLine",
    PaymentOnline = "PaymentOnline",
    PaymentOnlineCredit = "PaymentOnlineCredit",
    PaymentSalesEntry = "PaymentSalesEntry",
    PaymentSalesEntryLine = "PaymentSalesEntryLine",
    PaymentOffline = "PaymentOffline",
    PaymentOfflineLine = "PaymentOfflineLine",
    ProductGroup = "ProductGroup",
    Product = "Product",
    Coupon = "Coupon",
    Document = "Document",
    Event = "Event",
    EventBankEntry = "EventBankEntry",
}

export enum EventType {
    Undefined = "Undefined",
    Create = "Create",
    Update = "Update",
    Delete = "Delete",
    SystemSpecific = 'SystemSpecific',
}

export interface QueueLogMessage {
    partitionKey?: string | undefined;
    rowKey?: string | undefined;
    timestamp: string;
    eTag?: string | undefined;
    errorMessage?: string | undefined;
    errorFunctionalMessage?: string | undefined;
    errorType?: string | undefined;
    errorStackTrace?: string | undefined;
    errorSeverity?: LogMessageLevel;
    additionalInfo1?: string | undefined;
    additionalInfo2?: string | undefined;
}

export interface QueueLogMessageDto {
    rowKey?: string | undefined;
    objectType?: ObjectType | undefined;
    eventType?: EventType | undefined;
    relationId?: string | undefined;
    objectGuid?: string | undefined;
    timestamp: string;
    eTag?: string | undefined;
    errorMessage?: string | undefined;
    errorFunctionalMessage?: string | undefined;
    errorType?: string | undefined;
    errorStackTrace?: string | undefined;
    errorSeverity?: LogMessageLevel;
    additionalInfo1?: string | undefined;
    additionalInfo2?: string | undefined;
    errorLocation?: string | undefined;
    /** The message the way a person reads it: the text inside Exact's JSON error body. */
    errorText?: string | undefined;
    exactState?: ErrorRelationState;
    interpretation?: ErrorInterpretationDto | undefined;
    /** For an error no rule recognises: the code it shares with errors that say the same. */
    fingerprint?: string | undefined;
    /** For an error no rule recognises: what it says with the ids taken out. */
    fingerprintPattern?: string | undefined;
}

export enum ErrorRelationState {
    Unknown = "Unknown",
    NotInExact = "NotInExact",
    InExact = "InExact",
    Skipped = "Skipped",
    RemovedByChargeback = "RemovedByChargeback",
    ChargebackProcessed = "ChargebackProcessed",
}

export enum ErrorOwner {
    None = "None",
    Automatic = "Automatic",
    Support = "Support",
    Customer = "Customer",
}

export interface ErrorInterpretationDto {
    code?: string | undefined;
    title?: string | undefined;
    explanation?: string | undefined;
    owner?: ErrorOwner;
    requeueHelps?: boolean;
    action?: string | undefined;
    steps?: string[] | undefined;
    details?: string[] | undefined;
    evidence?: ErrorEvidenceDto[] | undefined;
}

export interface ErrorEvidenceDto {
    label?: string | undefined;
    value?: string | undefined;
    note?: string | undefined;
    warning?: boolean;
}

export interface RelationRequestDto {
    objectType?: ObjectType;
    leadingId?: string | undefined;
    dependingId?: string | undefined;
    countryCode?: string | undefined;
}

export interface RelationRequestUpdateDto {
    customerName?: string | undefined;
    environment?: string | undefined;
    leadingId?: string | undefined;
    dependingId?: string | undefined;
    countryCode?: string | undefined;
}

export interface RelationResponseDto {
    objectType?: ObjectType;
    leadingId?: string | undefined;
    dependingId?: string | undefined;
    countryCode?: string | undefined;
    source?: EventSource;
}

export interface RelationsRequestDto {
    customerName?: string | undefined;
    environment?: string | undefined;
    relations?: RelationRequestDto[] | undefined;
}

export interface ScenarioRunCheck {
    oracle?: string | undefined;
    name?: string | undefined;
    status?: string | undefined;
    expected?: string | undefined;
    actual?: string | undefined;
    detail?: string | undefined;
    topic?: string | undefined;
    rank?: number;
}

export interface ScenarioRunEvent {
    atUtc?: string;
    level?: string | undefined;
    scenarioId?: string | undefined;
    message?: string | undefined;
    step?: string | undefined;
}

export interface ScenarioRunDocument {
    name?: string | undefined;
    id?: string | undefined;
    stage?: string | undefined;
    detail?: string | undefined;
    sinceUtc?: string;
    amountInMinorUnits?: number | undefined;
    currency?: string | undefined;
    history?: ScenarioRunDocumentStage[] | undefined;
}

export interface ScenarioRunDocumentStage {
    stage?: string | undefined;
    atUtc?: string;
    detail?: string | undefined;
}

export interface ScenarioRunList {
    customer?: string | undefined;
    environment?: string | undefined;
    canStart?: boolean;
    startBlockedReason?: string | undefined;
    canManageSuites?: boolean;
    runs?: ScenarioRunSummary[] | undefined;
}

export interface ScenarioRunConfigurationRestore {
    status?: string | undefined;
    baselineTakenAtUtc?: string;
    takenOverFromRunId?: string | undefined;
    changes?: string[] | undefined;
    detail?: string | undefined;
}

export interface ScenarioRunProfile {
    id?: string | undefined;
    description?: string | undefined;
    featuresFrom?: string | undefined;
    featuresReadAtUtc?: string | undefined;
    status?: string | undefined;
    appliedConfiguration?: string[] | undefined;
    mode?: string | undefined;
    cacheCleared?: boolean;
    appliedHow?: string | undefined;
}

export interface ScenarioRunScenario {
    id?: string | undefined;
    profile?: string | undefined;
    description?: string | undefined;
    why?: string | undefined;
    tags?: string[] | undefined;
    status?: string | undefined;
    step?: string | undefined;
    startedAtUtc?: string | undefined;
    finishedAtUtc?: string | undefined;
    skipReason?: string | undefined;
    checks?: ScenarioRunCheck[] | undefined;
    warnings?: string[] | undefined;
    errors?: string[] | undefined;
    evidence?: { [key: string]: string; } | undefined;
    phases?: ScenarioRunPhase[] | undefined;
    documents?: ScenarioRunDocument[] | undefined;
    waitingUntilUtc?: string | undefined;
    connectorExactCalls?: ScenarioRunExactCallCount | undefined;
    runnerExactCalls?: ScenarioRunExactCallCount | undefined;
}

export interface ScenarioRunExactCallCount {
    total?: number;
    byCall?: { [key: string]: number; } | undefined;
}

export interface ScenarioRunExactCalls {
    total?: number;
    connector?: ScenarioRunExactCallCount | undefined;
    runner?: ScenarioRunExactCallCount | undefined;
    runnerPreflight?: ScenarioRunExactCallCount | undefined;
    runnerOutsideScenarios?: ScenarioRunExactCallCount | undefined;
}

export interface ScenarioRunStarted {
    runId?: string | undefined;
    customer?: string | undefined;
    environment?: string | undefined;
    suite?: string | undefined;
    only?: string[] | undefined;
    skip?: string[] | undefined;
    dryRun?: boolean;
    startedBy?: string | undefined;
    startedAtUtc?: string;
}

export interface ScenarioRunRequest {
    suite?: string | undefined;
    only?: string[] | undefined;
    skip?: string[] | undefined;
    dryRun?: boolean;
    stopOnFailure?: boolean;
}

export interface ScenarioSuiteSummary {
    id?: string | undefined;
    name?: string | undefined;
    updatedAtUtc?: string | undefined;
    description?: string | undefined;
    origin?: string | undefined;
    problem?: string | undefined;
    configurationProblem?: string | undefined;
    manualSteps?: string[] | undefined;
    profiles?: ScenarioSuiteProfile[] | undefined;
    scenarios?: ScenarioSuiteScenario[] | undefined;
    tags?: string[] | undefined;
}

export interface ScenarioSuiteProfile {
    id?: string | undefined;
    description?: string | undefined;
    featuresFrom?: string | undefined;
    featuresReadAtUtc?: string | undefined;
    featuresProblem?: string | undefined;
    configuration?: ScenarioProfileSetting[] | undefined;
    manualSteps?: string[] | undefined;
    ready?: boolean | undefined;
}

export interface ScenarioProfileSetting {
    kind?: string | undefined;
    name?: string | undefined;
    origin?: string | undefined;
    table?: string | undefined;
    partitionKey?: string | undefined;
    rowKey?: string | undefined;
    required?: string | undefined;
    current?: string | undefined;
    matches?: boolean | undefined;
}

export interface ScenarioSuiteScenario {
    id?: string | undefined;
    profile?: string | undefined;
    description?: string | undefined;
    why?: string | undefined;
    disabled?: boolean;
    tags?: string[] | undefined;
}

export interface ScenarioRunState {
    canStop?: boolean;
    runId?: string | undefined;
    suiteName?: string | undefined;
    suiteOrigin?: string | undefined;
    target?: string | undefined;
    buildVersion?: string | undefined;
    exactLimits?: ScenarioRunExactLimits | undefined;
    exactCalls?: ScenarioRunExactCalls | undefined;
    dryRun?: boolean;
    profileMode?: string | undefined;
    startedAtUtc?: string;
    updatedAtUtc?: string;
    finishedAtUtc?: string | undefined;
    status?: string | undefined;
    currentActivity?: string | undefined;
    totals?: ScenarioRunTotals | undefined;
    preflight?: ScenarioRunPreflightCheck[] | undefined;
    profiles?: ScenarioRunProfile[] | undefined;
    configurationRestore?: ScenarioRunConfigurationRestore | undefined;
    scenarios?: ScenarioRunScenario[] | undefined;
    events?: ScenarioRunEvent[] | undefined;
    phases?: ScenarioRunPhase[] | undefined;
}

export interface ScenarioRunExactLimits {
    dailyLimit?: number | undefined;
    dailyRemaining?: number | undefined;
    dailyResetsAtUtc?: string | undefined;
    minutelyLimit?: number | undefined;
    minutelyRemaining?: number | undefined;
    minutelyResetsAtUtc?: string | undefined;
    readAtUtc?: string;
}

export interface ScenarioRunPhase {
    id?: string | undefined;
    name?: string | undefined;
    startedAtUtc?: string;
    finishedAtUtc?: string | undefined;
}

export interface ScenarioRunPreflightCheck {
    id?: string | undefined;
    system?: string | undefined;
    name?: string | undefined;
    status?: string | undefined;
    expected?: string | undefined;
    actual?: string | undefined;
    detail?: string | undefined;
    blocks?: string[] | undefined;
}

export interface ScenarioRunSummary {
    canStop?: boolean;
    runId?: string | undefined;
    suiteName?: string | undefined;
    target?: string | undefined;
    status?: string | undefined;
    dryRun?: boolean;
    buildVersion?: string | undefined;
    startedAtUtc?: string;
    updatedAtUtc?: string;
    finishedAtUtc?: string | undefined;
    totals?: ScenarioRunTotals | undefined;
    scenarios?: ScenarioRunOutcome[] | undefined;
    runWarnings?: number;
    runErrors?: number;
    stale?: boolean;
}

export interface ScenarioRunOutcome {
    id?: string | undefined;
    outcome?: string | undefined;
    warnings?: number;
    errors?: number;
}

export interface ScenarioRunTotals {
    total?: number;
    passed?: number;
    failed?: number;
    skipped?: number;
    running?: number;
    pending?: number;
    warnings?: number;
    errors?: number;
}

export enum SettingName {
    None = "None",
    DiscountAsProduct = "DiscountAsProduct",
    CreditBalanceAdd = "CreditBalanceAdd",
    CreditBalanceUse = "CreditBalanceUse",
    CreditBalanceTax = "CreditBalanceTax",
    CreditBalanceLinePrefix = "CreditBalanceLinePrefix",
    CreditNoteJournal = "CreditNoteJournal",
    SalesInvoiceJournal = "SalesInvoiceJournal",
    SalesEntryJournal = "SalesEntryJournal",
    SalesEntryJournalCredit = "SalesEntryJournalCredit",
    PaymentOnlineJournal = "PaymentOnlineJournal",
    PaymentOnlineGlAccount = "PaymentOnlineGlAccount",
    TimeDifferenceExactServer = "TimeDifferenceExactServer",
    DefaultProductGroup = "DefaultProductGroup",
    SalesEntryCost = "SalesEntryCost",
    SubscriptionCodeField = "SubscriptionCodeField",
    ChargebeeApiKey = "ChargebeeApiKey",
    ChargebeeSiteName = "ChargebeeSiteName",
    ExactOnlineApiEndpoint = "ExactOnlineApiEndpoint",
    ExactTokenRefreshFunctionUrl = "ExactTokenRefreshFunctionUrl",
    ExactOnlineClientID = "ExactOnlineClientID",
    ExactOnlineClientSecret = "ExactOnlineClientSecret",
    ExactOnlineDivision = "ExactOnlineDivision",
    ExactOnlineRefreshToken = "ExactOnlineRefreshToken",
    ExactSendTransferQueueName = "ExactSendTransferQueueName",
    ChargebeeRetryTransferQueueName = "ChargebeeRetryTransferQueueName",
    MollieApiKey = "MollieApiKey",
    PromotionalCreditsProduct = "PromotionalCreditsProduct",
    DefaultProductGroupCoupons = "DefaultProductGroupCoupons",
    RedirectAdhocToSpecificExactProductCode = "RedirectAdhocToSpecificExactProductCode",
    ExactWebhookSubscriptionUrl = "ExactWebhookSubscriptionUrl",
}

export interface SettingRequestDeleteDto {
    customerName?: string | undefined;
    environment?: string | undefined;
    settingName?: SettingName;
}

export interface SettingRequestDto {
    customerName?: string | undefined;
    environment?: string | undefined;
    settingName?: SettingName;
    value1?: string | undefined;
    value2?: string | undefined;
}

export interface SettingResponseDto {
    settingName?: string | undefined;
    value1?: string | undefined;
    value2?: string | undefined;
    settingDescription?: string | undefined;
    settingStatus?: boolean;
}

export interface UpdateFeatureRequestDto {
    featureName?: FeatureName;
    featureStatus?: boolean;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}